import React, { MouseEventHandler, ReactNode } from 'react'
import { TableCell as MUITableCell, SxProps } from '@mui/material'

export interface TableCellProps {
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right'
  children: ReactNode
  className?: string
  component?: 'td' | 'th'
  padding?: 'checkbox' | 'none' | 'normal'
  scope?: string
  size?: 'medium' | 'small'
  sortDirection?: 'asc' | 'desc' | false
  style?: object
  sx?: SxProps
  variant?: 'body' | 'footer' | 'head'
  onClick?: (() => void) | MouseEventHandler<HTMLElement>
  colSpan?: number
}

/**
 * The TableCell component is a...
 */

const TableCell = React.forwardRef((props: TableCellProps, ref: any) => {
  const { children, component, ...rest } = props

  if (component === 'th') {
    return (
      <MUITableCell component="th" {...rest} ref={ref}>
        {children}
      </MUITableCell>
    )
  }

  return (
    <MUITableCell {...rest} ref={ref}>
      {children}
    </MUITableCell>
  )
})

TableCell.displayName = 'TableCell'
export default TableCell
